import * as Util from '../../util';
import BrowseLaneType from '../SavedFilters/Administer/BrowseLaneType';
import queryString from 'query-string';

export const setSavedFilters = filters => {
	const savedFilters =
		Array.isArray(filters) &&
		filters.map(filter => ({
			value: filter.code,
			label: filter.literal || filter.description,
			isExclusion: filter.isExclusion,
		}));
	return savedFilters || [];
};

export const getFilterDefinitionToSave = activeCategories => {
	const definition = activeCategories.reduce((definition, cat) => {
		const key = `refine_${cat.value.replace('~', '_')}`;
		definition[key] = cat.value;
		return definition;
	}, {});
	return definition;
};

export const getFilterRefinementDefinitionToSave = browseRefinements => {
	const definition = browseRefinements.reduce(
		(definition, browseRefinement) => {
			var typeKey = 0;
			var key = '';
			var code = browseRefinement.isExclusion ? '!' : '';
			switch (browseRefinement.browseLaneType) {
				case BrowseLaneType.DrcAvailability.key:
				case BrowseLaneType.PubDate.key:
					key = browseRefinement.browseLaneType;
					code += browseRefinement.code;
					break;
				case BrowseLaneType.Publisher.key:
					typeKey = BrowseLaneType.Publisher.typeKey;
					break;
				case BrowseLaneType.Format.key:
					typeKey = BrowseLaneType.Format.typeKey;
					break;
				case BrowseLaneType.AgeRange.key:
					typeKey = BrowseLaneType.AgeRange.typeKey;
					break;
				case BrowseLaneType.Imprint.key:
					typeKey = BrowseLaneType.Imprint.typeKey;
					break;
				case BrowseLaneType.Subrights.key:
					typeKey = BrowseLaneType.Subrights.typeKey;
					break;
				case BrowseLaneType.Dewey.key:
					typeKey = BrowseLaneType.Dewey.typeKey;
					break;
				case BrowseLaneType.Lexile.key:
					typeKey = BrowseLaneType.Lexile.typeKey;
					break;
				case BrowseLaneType.Edition.key:
					typeKey = BrowseLaneType.Edition.typeKey;
					break;
				case BrowseLaneType.Category.key:
					key = `refine_${browseRefinement.code.replace('~', '_')}`;
					code += browseRefinement.code;
					break;
				default:
					break;
			}
			if (typeKey > 0) {
				key = `refine_${typeKey}_${browseRefinement.code}`;
				code += `${typeKey}~${browseRefinement.code}`;
			}
			definition[key] = code;
			return definition;
		},
		{},
	);
	return definition;
};

export const getRelativeTimeframeAttributes = code => {
	const relativeTimeFrameAttribute = {
		startingRange: code.split(' TO ')[0].substring(1),
		endingRange: code.split('|')[1],
	};
	return relativeTimeFrameAttribute;
};

export const replaceExclusion = (activeCategories, value) => {
	return activeCategories.map(cat => {
		return {
			value: cat.value,
			label: cat.label,
			isExclusion:
				cat.value === value
					? cat.isExclusion
						? false
						: true
					: cat.isExclusion,
		};
	});
};

export const getBrowseFiltersByType = savedFilter => {
	return savedFilter.browseRefinements
		? Object.keys(
				Util.groupBy(savedFilter.browseRefinements, 'browseLaneType'),
		  )
		: [];
};

export const addSavedFiltersToState = (
	browseRefinements,
	activeCategories,
	browseLaneType,
	viewId,
) => {
	activeCategories.map(category => {
		var newRefinement = {
			viewId: viewId,
			browseLaneType: browseLaneType.key,
			code: category.value,
			literal: category.label,
			isExclusion: category.isExclusion,
		};
		browseRefinements.push(newRefinement);
	});
};

export const getDoJoinCommunityFromQueryParams = locationSearch => {
	const searchValues = queryString.parse(locationSearch);
	const { join } = searchValues;
	return join === 'true';
};
